module.exports = __webpack_public_path__ + "static/media/facebook.dca7f04c.svg";